import { render, staticRenderFns } from "./product_return_detail.vue?vue&type=template&id=aed7b392&"
import script from "./product_return_detail.vue?vue&type=script&lang=js&"
export * from "./product_return_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports